import {
  DataSourceRegistryItemAnnotation,
  DMLDataSourceAnnotation,
} from '../../types/schemas';

export const isDMLDataSource = (
  dataSource: DataSourceRegistryItemAnnotation,
): dataSource is DMLDataSourceAnnotation =>
  dataSource.name === 'dml' &&
  'apiPath' in dataSource &&
  typeof dataSource.apiPath === 'string';

export const findDMLDataSource = (
  sources: DataSourceRegistryItemAnnotation[] | undefined,
): DMLDataSourceAnnotation | undefined => {
  if (!sources) {
    return undefined;
  }
  const foundSource = sources.find(isDMLDataSource);
  if (foundSource) {
    return foundSource as DMLDataSourceAnnotation;
  }
  return undefined;
};
